import React from "react"
import clsx from "clsx"

import classes from "./TdFormLevelModalItem.module.scss"

const TdFormLevelModalItem = props => {
  const {
    item,
    isActive,
    setForm,
    setOpenModal
  } = props

  const handlePress = () => {
    setForm(prev => ({ ...prev, level: item }))

    setOpenModal(false)
  }

  return (
    <div
      onClick={handlePress}
      className={clsx([
        classes["button"],
        isActive && classes["active"]
      ])}
    >

      {item}
    </div>
  )
}

export default TdFormLevelModalItem